export default __webpack_public_path__ + "static/media/inspector-slice.a5805a9c.svg";